import axios from './axios';

function issuedItems({warehouse_id, start_at, end_at}) {
    return axios().get(`/warehouses/${warehouse_id}/issued-items`, {
        params: {start_at, end_at}
    })
}

function receivedItems({warehouse_id, start_at, end_at}) {
    return axios().get(`/warehouses/${warehouse_id}/received-items`, {
        params: {start_at, end_at}
    })
}

export default {
    issuedItems,
    receivedItems
}